import React, { useEffect, useState } from "react";
import "../styles/ReportsSection.css";
import ChartComponent from "./ChartComponent";
import AppealTrendChart from "./AppealTrendChart";
import Tabs from "./Tabs";
import useWebSocketService from "../ws-service";
import ChartBarSerial from "./charts/ChartBarSerial";
import {AddressData, ContractData, TableBySerialData} from "./charts/types";
import ChartBarContract from "./charts/ChartBarContract";
import ChartBarAddress from "./charts/ChartBarAddress";

interface ChartData {
  horizontalStart: string;
  HorizontalEnd: string;
  verticalSize: number;
  points: {
    problem_lvl_low: { horizontal: string; vertical: number }[];
    problem_lvl_mid: { horizontal: string; vertical: number }[];
    problem_lvl_standart: { horizontal: string; vertical: number }[];
    problem_lvl_high: { horizontal: string; vertical: number }[];
    problem_lvl_critical: { horizontal: string; vertical: number }[];
  };
}

const ReportsSection: React.FC = () => {
  const [chartData, setChartData] = useState({
    Success: {
      low: 0,
      mid: 0,
      standart: 0,
      high: 0,
      critical: 0,
    },
    Query: {
      low: 0,
      mid: 0,
      standart: 0,
      high: 0,
      critical: 0,
    },
    Working: {
      low: 0,
      mid: 0,
      standart: 0,
      high: 0,
      critical: 0,
    },
  });

  const [chartDataForSecondChart, setChartDataForSecondChart] =
    useState<ChartData | null>(null);
  const [chartDataForSerial, setChartDataForSerial] =
    useState<TableBySerialData | null>(null);
  const [chartDataForContract, setChartDataForContract] =
    useState<ContractData | null>(null);
  const [chartDataForAddress, setChartDataForAddress] =
      useState<AddressData | null>(null);
  const { get } = useWebSocketService();

  const userName = sessionStorage.getItem("userName") || "default_user";

  useEffect(() => {
    window.ws.onmessage = (event: MessageEvent) => {
      const message = JSON.parse(event.data)?.message;
      if (message?.type == "table_critical_rate") {
        setChartData(message.data);
      } else if (message?.type == "table_count_appeals") {
        setChartDataForSecondChart(message.data);
      } else if (message?.type == "table_by_serial") {
        setChartDataForSerial(message.data);
      } else if (message?.type == "table_by_contract") {
        setChartDataForContract(message.data);
      }else if (message?.type == "table_by_address") {
        setChartDataForAddress(message.data);
      }
    };
    window.ws.send(
      JSON.stringify({
        action: "TABLE_CRITICAL_RATE",
        user_name: userName,
      }),
    );
    window.ws.send(
      JSON.stringify({
        action: "TABLE_COUNT_APPEALS",
        user_name: userName,
      }),
    );
    window.ws.send(
      JSON.stringify({
        action: "TABLE_BY_SERIAL",
        user_name: userName,
      }),
    );
    window.ws.send(
      JSON.stringify({
        action: "TABLE_BY_CONTRACT",
        user_name: userName,
      }),
    );
    window.ws.send(
        JSON.stringify({
          action: "TABLE_BY_ADDRESS",
          user_name: userName,
        }),
    );
  }, []);

  return (
    <div className="reports-section-content">
      <h2>Отчеты</h2>
      <Tabs
          labels={[
            "Критичность",
            "Уровень критичности",
            "Оборудование",
            "Договор",
            "Адрес",
          ]}
      >
        <div className="chart-container">
          <ChartComponent data={chartData} maxY={10}/>
        </div>
        <div className="chart-container">
          {chartDataForSecondChart ? (
              <AppealTrendChart data={chartDataForSecondChart}/>
          ) : (
              <p>Загрузка данных для графика...</p>
          )}
        </div>
        <div className="chart-container">
          {chartDataForSerial ? (
              <ChartBarSerial
                  serials={chartDataForSerial.serials}
                  verticalSize={chartDataForSerial.verticalSize}
              />
          ) : (
              <p>Загрузка данных графика...</p>
          )}
          <p>Используйте колесо мыши для масштабирования</p>
        </div>
        <div className="chart-container">
          {chartDataForContract ? (
              <ChartBarContract
                  verticalSize={chartDataForContract.verticalSize}
                  contracts={chartDataForContract.contracts}
              />
          ) : (
              <p>Загрузка данных для графика...</p>
          )}
          <p>Используйте колесо мыши для масштабирования</p>
        </div>
        <div className="chart-container">
          {chartDataForAddress ? (
              <ChartBarAddress
                  verticalSize={chartDataForAddress.verticalSize}
                  addreses={chartDataForAddress.addreses}
              />
          ) : (
              <p>Загрузка данных для графика...</p>
          )}
          <p>Используйте колесо мыши для масштабирования</p>
        </div>
      </Tabs>
    </div>
  );
};

export default ReportsSection;
